module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/Adriannt/Desktop/2021.1/02 participaciones/zm_participaciones/participaciones/node_modules/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = polyfills